module.exports = __webpack_public_path__ + "static/media/ROHIT-PAWAR.97a6efb6.png";